<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>Separation Checklist</h1>
        <p>This document is a guide listing items for you to consider when separating, especially at the early stages. It is recommended that if you are unsure about any of the items in the checklist to please contact your family law professional. Every divorce is unique and individual advice tailored to your situation is required.</p>
        <app-activity-indicator v-if="loading"></app-activity-indicator>
        <v-expansion-panels v-else>
          <v-expansion-panel v-for="(group, index) in checklistItems" :key="index">
              <v-expansion-panel-header>
                <v-col cols="12">
                  <div class="subtitle-2">{{heading(group)}}</div>
                </v-col>
                <!-- <v-col cols="6">
                  <v-progress-linear v-model="group.progress" color="teal" height="25">{{ progressLabel(group) }}</v-progress-linear>
                </v-col> -->
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <template v-for="(item, index) in group.items">
                      <v-checkbox @change="change" :key="index" v-if="item.type == 'checkbox'"  v-model="item.value"  color="teal" :label="item.label"></v-checkbox>
                      <div :key="index" v-if="item.type == 'subheading'" class="subheading">{{item.label}}</div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mt-2">
        <p>Further information and support is available at Divorce Answered in blogs, with unique tools and strategy sessions.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
  }),
  methods: {
    change (value, item) {
      this.$store.dispatch('checklists/update')
    },
    progressLabel (group) {
      var total = 0
      var count = 0
      group.items.forEach(element => {
        if (element.value) {
          count++
        }
        if (element.type === 'checkbox') {
          total++
        }
      })
      return `${count}/${total}`
    },
    heading (group) {
      var total = 0
      var count = 0
      group.items.forEach(element => {
        if (element.value) {
          count++
        }
        if (element.type === 'checkbox') {
          total++
        }
      })
      return `${group.heading} [${count}/${total}]`
    }
  },
  created () {
    this.$store.dispatch('checklists/view')
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    checklistItems () {
      return this.$store.state.checklists?.loadedChecklist?.data || {}
    }
  }
}
</script>
